// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_1yloB","headItem":"index_headItem_3C1k1","headIcon":"index_headIcon_1LJrg"};